import {
  DRAWER_PLACEMENTS,
  NOTIFICATION_TYPES, OPERATIONS,
} from "../../../../../config/constants";
import {
  Empty,
  Select,
  Button,
  Form,
  Input,
  Checkbox,
  Drawer,
  Space,
  Pagination,
  AutoComplete,
  Collapse,
  InputNumber, Popconfirm,
  Modal,
} from "antd";
import "./ValidationRules.css";
import {
  CheckOutlined,
  EditOutlined,
  CloseOutlined,
  ExperimentOutlined,
  ForwardOutlined,
  CopyOutlined, QuestionCircleOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import Datatable from "../../../../shared/components/Datatable";
import { ColumnsType } from "antd/lib/table";
import ValidationRulesService from "../../../../../services/validationrules/ValidationRulesService";
import TablesService from "../../../../../services/tables/TablesService";
import { GetTablesRequest } from "../../../../../models/tables/GetTablesRequest";
import { GetFieldsRequest } from "../../../../../models/fields/GetFieldsRequest";
import { UpdateValidationModel } from "../../../../../models/validationrules/UpdateValidationModel";
import { CreateValidationModel } from "../../../../../models/validationrules/CreateValidationModel";
import { useTranslation } from "react-i18next";
import NotificationsUtil from "../../../../shared/utils/NotificationsUtil";
import { TestValidationRuleRequest } from "../../../../../models/validationrules/TestValidationRuleRequest";
import TextArea from "antd/lib/input/TextArea";
import styles from "./ValidationRules.module.css";
import history from "../../../../shared/utils/HistoryUtil";
import EnvironmentService from "../../../../../services/environments/EnvironmentService";
import ReferenceService from "../../../../../services/references/ReferencesService";
import {useDispatch, useSelector} from "react-redux";
import {setTestEnvironment} from "../../../../../redux/actions";

const { Panel } = Collapse;

const ValidationRules = ({
  entities,
  groupCodes,
  selectedEntity,
  selectedGroupCode,
  selectable,
  multiSelect,
  selectedRows,
  setSelectedRows,
  setNewValidationRuleModalEnabled,
  newValidationRuleModalEnabled,
}: {
  entities: any;
  groupCodes: any;
  selectedEntity: any;
  selectedGroupCode: any;
  selectable: boolean;
  multiSelect: boolean;
  selectedRows: any;
  setSelectedRows: any;
  setNewValidationRuleModalEnabled: (val: boolean) => void;
  newValidationRuleModalEnabled: boolean;
}) => {
  const dispatch = useDispatch();
  
  const { t, i18n } = useTranslation("translations");

  enum RowAction {
    View = 1,
    Edit,
    Create,
  }

  interface DataType {
    groupCode: any;
    fieldName: any;
    key: string;
    id: number;
    field: string;
    category: string;
    description: string;
    mandatory: boolean;
    isActive: boolean;
    isAutomaticRule: boolean;
  }

  const { testEnvironment } = useSelector((state: any) => ({ testEnvironment: state.testEnvironment }));

  const [data, setData] = useState<DataType[]>([]);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [drawerAction, setDrawerAction] = useState<RowAction>();
  const [drawerTitle, setDrawerTitle] = useState<any>("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editedRow, setEditedRow] = useState<any>();
  const [originalEditedRow, setOriginalEditedRow] = useState<any>();
  const [groupCodeInput, setGroupCodeInput] = useState("");
  const [entityInput, setEntityInput] = useState("");
  const [fieldInput, setFieldInput] = useState("");
  const [categoryInput, setCategoryInput] = useState<any>("");
  const [descriptionInput, setDescriptionInput] = useState("");
  const [mandatoryInput, setMandatoryInput] = useState(false);
  const [IsAutomaticRuleInput, setIsAutomaticRule] = useState(false);
  const [activeInput, setActiveInput] = useState(false);
  const [destinationTable, setDestinationTable] = useState(null);
  const [dependencyInput, setDependencyInput] = useState<any>();
  const [fields, setFields] = useState<any>([]);
  const [categories, setCategories] = useState<any>(null);
  const [ruleInput, setRuleInput] = useState("");
  const [joinInput, setJoinInput] = useState("");
  const [issueValueInput, setIssueValueInput] = useState("");
  const [customFieldsInput, setCustomFieldsInput] = useState("");
  const [whereInput, setWhereInput] = useState("");
  const [upsertButtonEnabled, setUpsertButtonEnabled] = useState(false);
  const [sequenceInput, setSequenceInput] = useState<number>(0);
  const [longDescriptionInput, setLongDescriptionInput] = useState("");
  const [howToSolveInput, setHowToSolveInput] = useState("");
  const [whoToSolveInput, setWhoToSolveInput] = useState("");
  const [issueOwnerInput, setIssueOwnerInput] = useState("");
  const [proposedSolutionInput, setProposedSolutionInput] = useState("");

  const [loadingButton, setLoadingButton] = useState(false);
  const [id, setId] = useState("");

  const [testRow, setTestRow] = useState<any>(null);

  const [openTestDrawer, setOpenTestDrawer] = useState(false);
  const [isTestTableLoading, setIsTestTableLoading] = useState<boolean>(false);

  const [viewTablePageIndex, setViewTablePageIndex] = useState(1);
  const [viewTablePageSize, setViewTablePageSize] = useState(10);

  const [testTableViewData, setTestTableViewData] = useState<any>([]);
  const [testTableColumns, setTestTableColumns] = useState<
    ColumnsType<DataType>
  >([]);
  const [selectedTestGroupCode, setSelectedTestGroupCode] = useState<any>();

  const [updateValidationRuleDisabled, setUpdateValidationRuleDisabled] =
    useState<any>(false);

  const [isDirty, setIsDirty] = useState<any>(false);
  const [popConfirmOpen, setPopConfirmOpen] = useState<boolean>(false);

  const [environment, setEnvironments] = useState<any>([]);
  const [selectedEnvironment, setSelectedEnvironment] = useState<any>();

  const [testValidationRuleForm] = Form.useForm();

  const [validationTypeModalVisible, setValidationTypeModalVisible] = useState<boolean>(false);
  const [validationTypes, setValidationTypes] = useState<string[]>([]);
  const [selectedValidationType, setSelectedValidationType] = useState<string>("");

  const [showMandatoryWarning, setShowMandatoryWarning] = useState<boolean>(false);



  useEffect(() => {
    if (editedRow && data) {
      const current = JSON.stringify(editedRow);
      
      let rule = data.find((x: any) => x.id === id);
      const def = JSON.stringify(rule);

      if (!editedRow?.entityID || editedRow?.entityID?.length === 0) {
        setUpsertButtonEnabled(false);
        return;
      }

      if (!editedRow?.fieldID || editedRow?.fieldID?.length === 0) {
        setUpsertButtonEnabled(false);
        return;
      }

      if (!editedRow?.category || editedRow?.category?.length === 0) {
        setUpsertButtonEnabled(false);
        return;
      }

      if (!editedRow?.description || editedRow?.description?.length === 0) {
        setUpsertButtonEnabled(false);
        return;
      }

      if (!def) {
        setUpsertButtonEnabled(true);
        return;
      }

      if (current !== def) {
        setUpsertButtonEnabled(true);
      } else {
        setUpsertButtonEnabled(false);
      }
    } else {
      setUpsertButtonEnabled(false);
    }
  }, [editedRow, data, id]);

  useEffect(() => {
    setShowMandatoryWarning(fields.find((x: any) => x.id.toString() === editedRow.fieldID)?.isMandatory ?? false);
  }, [fields]);

  useEffect(() => {
    if (!isDirty) return;

    const unblock = history.block((tx: any) => {
      if (
        window.confirm(
          "Are you sure you want leave the page without saving? Current changes will be lost."
        )
      ) {
        unblock();
        tx.retry();
      }
    });

    return () => {
      unblock();
    };
  }, [isDirty]);

  useEffect(() => {
    if (editedRow && originalEditedRow) {
      if (!upsertButtonEnabled) {
        setIsDirty(false);
      } else {
        setIsDirty(true);
      }
    } else {
      setIsDirty(false);
    }
  }, [upsertButtonEnabled]);

  useEffect(() => {
    EnvironmentService.getAll().then((response: any) => {
      const data = response.data;
      setEnvironments(data);
    });
  }, []);

  useEffect(() => {
    if (editedRow && originalEditedRow) {
      const current = JSON.stringify(editedRow);
      const def = JSON.stringify(originalEditedRow);
      if (current !== def) {
        setUpdateValidationRuleDisabled(false);
      } else {
        setUpdateValidationRuleDisabled(true);
      }
    } else {
      setUpdateValidationRuleDisabled(false);
    }
  }, [editedRow, originalEditedRow]);

  useEffect(() => {
    if (openTestDrawer) {
      runTest(true);
    }
  }, [openTestDrawer]);

  const showDrawer = (action: RowAction, recordId: any = null, name: string = "") => {
    setDrawerAction(action);
    switch (action) {
      case RowAction.View:
        setDrawerTitle(
          t(
            "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.RowDetails",
            {
              lngs: i18n.languages,
              defaultValue: "Row details",
            }
          )!
        );
        break;
      case RowAction.Create:
        setDrawerTitle(
          t(
            "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.NewValidationRule",
            {
              lngs: i18n.languages,
              defaultValue: "New validation rule",
            }
          )!
        );
        break;
      case RowAction.Edit:
        setDrawerTitle(
          <>
            <span>
              {t(
                "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.EditValidationRule",
                {
                  lngs: i18n.languages,
                  defaultValue: "Edit validation rule",
                }
              )} {name ? " - " + name : ""}
            </span>
            <span style={{ marginLeft: "10px", color: "grey", fontSize: 12 }}>
              {recordId}
            </span>
          </>
        );
        break;
      default:
        break;
    }
    setActiveInput(true);
    setMandatoryInput(true)
    setIsAutomaticRule(false);
    setOpenDrawer(true);
  };

  const onClose = () => {
    setGroupCodeInput("");
    setEntityInput("");
    setOpenDrawer(false);
    setFieldInput("");
    setCategoryInput("");
    setDescriptionInput("");
    setDependencyInput("");
    setMandatoryInput(false);
    setIsAutomaticRule(false);
    setActiveInput(false);
    setRuleInput("");
    setJoinInput("");
    setIssueValueInput("");
    setCustomFieldsInput("");
    setWhereInput("");
    setEditedRow(null);
    setDependencyInput("");
    setNewValidationRuleModalEnabled(false);
    setTestRow(null);
    setOriginalEditedRow(null);
    setId("");
    setSequenceInput(0);
    setLongDescriptionInput("");
    setHowToSolveInput("");
    setWhoToSolveInput("");
    setIssueOwnerInput("");
    setProposedSolutionInput("");
    setSelectedValidationType("");
    setSelectedValidationType("");
  };

  const onEditValidation = (record: any) => {
    showDrawer(RowAction.Edit, record.id, record.description);
    setGroupCodeInput(record.groupCode);
    setEntityInput(record.entityID);
    setFieldInput(record.fieldID);
    setShowMandatoryWarning(fields.find((x: any) => x.id.toString() === record.fieldID)?.isMandatory ?? false);
    setCategoryInput(record.categoryId);
    setDescriptionInput(record.description);
    setDependencyInput(record.dependencyEntityId);
    setMandatoryInput(record.mandatory);
    setIsAutomaticRule(record.isAutomaticRule);
    setActiveInput(record.isActive);
    setRuleInput(record.rule);
    setJoinInput(record.join);
    setIssueValueInput(record.value);
    setCustomFieldsInput(record.customFields);
    setWhereInput(record.where);
    setEditedRow(record);
    setOriginalEditedRow(record);
    setId(record.id);
    setSequenceInput(record.seq);
    setLongDescriptionInput(record.longDescr);
    setHowToSolveInput(record.howToSolve);
    setWhoToSolveInput(record.whoToSolve);
    setIssueOwnerInput(record.issueOwner);
    setProposedSolutionInput(record.proposedSolution);
  };

  const onCopyValidation = (record: any) => {
    showDrawer(RowAction.Create);
    setOriginalEditedRow(record);
    
    record.id = undefined;
    setEditedRow(record);
    setGroupCodeInput(record.groupCode);
    setEntityInput(record.entityID);
    setFieldInput(record.fieldID);
    setCategoryInput(record.categoryId);
    setDescriptionInput(record.description);
    setDependencyInput(record.dependencyEntityId);
    setMandatoryInput(record.mandatory);
    setIsAutomaticRule(record.isAutomaticRule);
    setRuleInput(record.rule);
    setJoinInput(record.join);
    setId(undefined);
    setIssueValueInput(record.value);
    setCustomFieldsInput(record.customFields);
    setWhereInput(record.where);
    setActiveInput(record.isActive);
    setSequenceInput(record.seq);
    setLongDescriptionInput(record.longDescr);
    setHowToSolveInput(record.howToSolve);
    setWhoToSolveInput(record.whoToSolve);
    setIssueOwnerInput(record.issueOwner);
    setProposedSolutionInput(record.proposedSolution);
  };

  const onDeleteValidation = (id: number) => {
    ValidationRulesService.remove(id)
      .then((response: any) => {
        setIsTableLoading(true);
        NotificationsUtil.openNotificationDialog({
          description: t(
            "Page.Operation.ValidationRules.Tabs.ValidationRules.Notifications.ValidationRule.DeleteSuccessDescription",
            {
              lngs: i18n.languages,
              defaultValue: "Validation rule deleted successfully.",
            }
          )!,
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        });
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
      });
  };

  const onDoubleClickRow = (record: any) => {
    showDrawer(RowAction.View);
    setEntityInput(record.entityID);
    setFieldInput(record.fieldID);
    setCategoryInput(record.categoryId);
    setDescriptionInput(record.description);
    setDependencyInput(record.dependencyEntityId);
    setMandatoryInput(record.mandatory);
    setIsAutomaticRule(record.isAutomaticRule);
    setActiveInput(record.isActive);
    setRuleInput(record.rule);
    setJoinInput(record.join);
    setIssueValueInput(record.value);
    setCustomFieldsInput(record.customFields);
    setWhereInput(record.where);
    setGroupCodeInput(record.groupCode);
    setEditedRow(record);
    setId(record.id);
    setSequenceInput(record.seq);
    setLongDescriptionInput(record.longDescr);
    setHowToSolveInput(record.howToSolve);
    setWhoToSolveInput(record.whoToSolve);
    setIssueOwnerInput(record.issueOwner);
    setProposedSolutionInput(record.proposedSolution);
  };

  const onSaveValidation = () => {
    setLoadingButton(true);
    if (editedRow?.id) {
      const model: UpdateValidationModel = {
        id: editedRow.id,
        GroupCode: groupCodeInput,
        FkEntity: entityInput,
        FkField: fieldInput,
        Rule: `${groupCodeInput}.${entityInput}.${fieldInput}`,
        Description: descriptionInput,
        RuleSQL: ruleInput,
        JoinSQL: joinInput,
        IssueValue: issueValueInput,
        CustomFields: customFieldsInput,
        Where: whereInput,
        // Severity: ;
        Mandatory: mandatoryInput,
        CategoryId: categoryInput,
        DependencyEntityId: categoryInput === 2 ? dependencyInput : null,
        IsActive: activeInput,
        Seq: sequenceInput,
        LongDescr: longDescriptionInput,
        HowToSolve: howToSolveInput,
        WhoToSolve: whoToSolveInput,
        IssueOwner: issueOwnerInput,
        ProposedSolution: proposedSolutionInput,
      };
      ValidationRulesService.update(model)
        .then((response: any) => {
          setIsTableLoading(true);
          onClose();
          setGroupCodeInput("");
          setEntityInput("");
          setOpenDrawer(false);
          setFieldInput("");
          setCategoryInput("");
          setDescriptionInput("");
          setMandatoryInput(false);
          setIsAutomaticRule(false);
          setActiveInput(false);
          setRuleInput("");
          setJoinInput("");
          setIssueValueInput("");
          setCustomFieldsInput("");
          setWhereInput("");
          setLoadingButton(false);
          setId("");
          setSequenceInput(0);
          setLongDescriptionInput("");
          setHowToSolveInput("");
          setWhoToSolveInput("");
          setIssueOwnerInput("");
          setProposedSolutionInput("");
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Notifications.ValidationRule.UpdateSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "Validation rule edited successfully.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
        })
        .catch((error: any) => {
          setLoadingButton(false);
          NotificationsUtil.openNotificationDialog({
            description: error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        });
    } else {
      const model: CreateValidationModel = {
        GroupCode: groupCodeInput,
        FkEntity: entityInput,
        FkField: fieldInput,
        Rule: `${groupCodeInput}.${entityInput}.${fieldInput}`,
        Description: descriptionInput,
        RuleSQL: ruleInput,
        JoinSQL: joinInput,
        IssueValue: issueValueInput,
        CustomFields: customFieldsInput,
        Where: whereInput,
        // Severity: ;
        Mandatory: mandatoryInput,
        isAutomaticRule: IsAutomaticRuleInput,
        CategoryId: categoryInput,
        DependencyEntityId: categoryInput === 2 ? dependencyInput : null,
        Seq: sequenceInput,
        LongDescr: longDescriptionInput,
        HowToSolve: howToSolveInput,
        WhoToSolve: whoToSolveInput,
        IssueOwner: issueOwnerInput,
        ProposedSolution: proposedSolutionInput,
      };
      ValidationRulesService.create(model)
        .then((response: any) => {
          setIsTableLoading(true);
          onClose();
          setGroupCodeInput("");
          setEntityInput("");
          setOpenDrawer(false);
          setFieldInput("");
          setCategoryInput("");
          setDescriptionInput("");
          setMandatoryInput(false);
          setIsAutomaticRule(false);
          setActiveInput(false);
          setRuleInput("");
          setId("");
          setJoinInput("");
          setIssueValueInput("");
          setCustomFieldsInput("");
          setWhereInput("");
          setLoadingButton(false);
          setSequenceInput(0);
          setLongDescriptionInput("");
          setHowToSolveInput("");
          setWhoToSolveInput("");
          setIssueOwnerInput("");
          setProposedSolutionInput("");
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Notifications.ValidationRule.CreateSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "Validation rule created successfully.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
        })
        .catch((error: any) => {
          let errorData = error.response.data;
          if (error.code === "ERR_BAD_REQUEST") {
            errorData = error.response.data.title;
            errorData += "\n";
            errorData += JSON.stringify(error.response.data.errors);
          }
          setLoadingButton(false);
          NotificationsUtil.openNotificationDialog({
            description: error.response.data.errors ? errorData : error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        });
    }
  };

  const onGroupCodeChange = (value: string) => {
    setGroupCodeInput(value);

    setTestRow({ ...testRow, groupCode: value });
    setEditedRow({ ...editedRow, groupCode: value });
  };
  
  const onMandatoryChange = (value: boolean) => {
    setMandatoryInput(value);
    setEditedRow({...editedRow, mandatory: value});
  }

  const onActiveChange = (value: boolean) => {
    setActiveInput(value);
    setEditedRow({...editedRow, isActive: value});
  }
  
  const onEntityChange = (value: string) => {
    setEntityInput(value);

    const entityName = entities.find((x: any) => x.id === value)?.name;
    setTestRow({ ...testRow, entity: entityName });
    setEditedRow({ ...editedRow, entityID: value });
  };
  const onFieldChange = (value: string) => {
    setShowMandatoryWarning(fields.find((x: any) => x.id.toString() === value)?.isMandatory ?? false);
    
    setFieldInput(value);

    setTestRow({ ...testRow, field: value });
    setEditedRow({ ...editedRow, fieldID: value });
  };
  const onCategoryChange = (value: string) => {
    setCategoryInput(value);
    setEditedRow({ ...editedRow, category: value });
  };
  const onDependencyChange = (value: string) => {
    setDependencyInput(value);
    setEditedRow({ ...editedRow, dependencyEntityId: value });
  };

  const onDescriptionInputChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setDescriptionInput(event.target.value);
    setEditedRow({ ...editedRow, description: event.target.value });
  };

  const onRuleTitleInputChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setDescriptionInput(event.target.value);
    setEditedRow({...editedRow, description: event.target.value})
  };

  const onSequenceInputChange: React.ChangeEventHandler<
    HTMLInputElement
    > = (event) => {
    const { value: inputValue } = event.target;
      const reg = /^-?\d*(\.\d*)?$/;
      if (inputValue === '') {
        setSequenceInput(0);
        setEditedRow({...editedRow, seq: 0})
      }
      if (reg.test(inputValue) && inputValue !== '') {
          setSequenceInput(parseInt(inputValue));
          setEditedRow({...editedRow, seq: inputValue})
      }
    };

  const onLongDescriptionInputChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setLongDescriptionInput(event.target.value);
    setEditedRow({...editedRow, longDescription: event.target.value})
    };

  const onHowToSolveInputChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setHowToSolveInput(event.target.value);
    setEditedRow({...editedRow, howToSolve: event.target.value})
    };

  const onWhoToSolveInputChange: React.ChangeEventHandler<
      HTMLTextAreaElement
  > = (event) => {
    setWhoToSolveInput(event.target.value);
    setEditedRow({...editedRow, whoToSolve: event.target.value})
  };

  const onIssueOwnerInputChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setIssueOwnerInput(event.target.value);
    setEditedRow({...editedRow, issueOwner: event.target.value})
    };

  const onProposedSolutionInputChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setProposedSolutionInput(event.target.value);
    setEditedRow({...editedRow, proposedSolution: event.target.value})
  };

  const onRuleInputChange: React.ChangeEventHandler<HTMLTextAreaElement> = (
    event
  ) => {
    setTestRow({ ...testRow, rule: event.target.value });
    setEditedRow({...editedRow, rule: event.target.value})
    setRuleInput(event.target.value);
  };

  const onJoinInputChange: React.ChangeEventHandler<HTMLTextAreaElement> = (
    event
  ) => {
    setTestRow({ ...testRow, join: event.target.value });
    setEditedRow({...editedRow, join: event.target.value})
    setJoinInput(event.target.value);
  };

  const onIssueValueInputChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setTestRow({ ...testRow, issueValue: event.target.value });
    setEditedRow({...editedRow, value: event.target.value});
    setIssueValueInput(event.target.value);
  };

  const onShowTestDrawer = () => {
    setOpenTestDrawer(true);
  };

  const onCloseTestDrawer = () => {
    setTestTableViewData([]);
    setTestTableColumns([]);
    setTestRow({ ...testRow, sqlCode: "" });
    setOpenTestDrawer(false);
  };

  const onTestApplyChanges = () => {
    setEditedRow({
      ...editedRow,
      fromValue: testRow?.fromValue,
      join: testRow?.join,
      customFields: testRow?.customFields,
      rule: testRow?.rule,
      issueValue: testRow?.issueValue,
      where: testRow?.where,
    });
    setRuleInput(testRow?.rule);
    setJoinInput(testRow?.join);
    setIssueValueInput(testRow?.issueValue)
    setOpenTestDrawer(false);
    setWhereInput(testRow?.where);
    setCustomFieldsInput(testRow?.customFields);
  };

  const runTest = (generateOnlyQuery: boolean) => {
    if (!generateOnlyQuery) {
      setIsTestTableLoading(true);
    }
    
    const fieldName = fields.find(
      (x: any) => x.id.toString() === testRow.field
    )?.name;
    const model: TestValidationRuleRequest = {
      entity: testRow?.entity,
      // groupCode: testRow.groupCode,
      // fromField: testRow.fromField,
      groupCode: testRow?.groupCode,
      environment: selectedEnvironment,
      field: fieldName ? fieldName?.replaceAll("\n", " ") : "",
      rule: testRow?.rule ? testRow?.rule?.replaceAll("\n", " ") : "",
      issueValue: testRow?.issueValue
        ? testRow?.issueValue?.replaceAll("\n", " ")
        : "",
      customFields: testRow?.customFields
        ? testRow?.customFields?.replaceAll("\n", " ")
        : "",
      join: testRow?.join ? testRow?.join?.replaceAll("\n", " ") : "",
      where: testRow?.where ? testRow?.where?.replaceAll("\n", " ") : "",
      sqlCode: testRow?.sqlCode,
      fetchOnlySQLQuery: generateOnlyQuery,
      dependencyEntityId: editedRow?.dependencyEntityId,
    };
    ValidationRulesService.test(model)
      .then((response: any) => {
        const styledSqlCode = addNewLineOnJoins(response.data.sqlCode);
        setTestRow({ ...testRow, sqlCode: styledSqlCode });

        if (response.data.data.length > 0) {
          const columnKeys = Object.keys(response.data.data[0]);
          setTestTableColumns(
            columnKeys.map((item: any) => ({
              title: item,
              dataIndex: item,
              key: item,
              width: 200,
              filters: [],
              fitlerMode: "tree",
              filterSearch: true,
              ellipsis: true,
            }))
          );
        }
        setTestTableViewData(response.data.data);
        // NotificationsUtil.openNotificationDialog({
        //   description: t(
        //     "Page.Operation.ValidationRules.Tabs.ValidationMapping.Notifications.ValidationMappingTest.RunSuccessDescription",
        //     {
        //       lngs: i18n.languages,
        //       defaultValue: "Query has executed successfully.",
        //     }
        //   )!,
        //   type: NOTIFICATION_TYPES.SUCCESS,
        // });
        setIsTestTableLoading(false);
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
        setIsTestTableLoading(false);
      });
  };

  const addNewLineOnJoins = (sqlCode: string) => {
    const joinStatements = ['INNER JOIN', 'LEFT JOIN', 'LEFT OUTER JOIN', 'FULL OUTER JOIN'];
    joinStatements.forEach(joinStatement => {
      sqlCode = sqlCode.replaceAll(joinStatement, `\n${joinStatement}`)
    });
      
    return sqlCode;
  }

  const onTestGroupCodeChange = (value: string) => {
    setSelectedTestGroupCode(value);
    setTestRow({ ...testRow, groupCode: value });
  };

  const onSelectedTestCustomFieldsChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setTestRow({ ...testRow, customFields: event.target.value });
  };

  const onSelectedTestJoinChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setTestRow({ ...testRow, join: event.target.value });
  };
  
  const onSelectedTestWhereChange: React.ChangeEventHandler<
      HTMLTextAreaElement
  > = (event) => {
    setTestRow({ ...testRow, where: event.target.value });
  };

  const onSelectedTestRuleChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setTestRow({ ...testRow, rule: event.target.value });
  };

  const onSelectedTestIssueValueChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setTestRow({ ...testRow, issueValue: event.target.value });
  };

  const onEnvironmentChange = (value: string) => {
    setSelectedEnvironment(value);
    dispatch(setTestEnvironment(value));
  };

  useEffect(() => {
    if (testRow) {
      testValidationRuleForm.setFieldsValue({
        groupCode: testRow.groupCode,
        field: testRow.field,
        rule: testRow.rule,
        issueValue: testRow.issueValue,
        customFields: testRow.customFields,
        join: testRow.join,
        where: testRow.where,
        sqlCode: testRow.sqlCode,
      });
    } else {
      testValidationRuleForm.setFieldsValue({
        groupCode: null,
        rule: "",
        issueValue: "",
        customFields: "",
        join: "",
        where: "",
        field: null,
        sqlCode: "",
      });
    }
  }, [testRow]);

  useEffect(() => {
    if (editedRow) {
      setTestRow({
        entity: entities.find((x: any) => x.id === selectedEntity)?.name,
        groupCode: selectedGroupCode,
        environment: testEnvironment,
        field: editedRow?.fieldID,
        rule: editedRow?.rule,
        issueValue: editedRow?.value,
        join: editedRow?.join,
        customFields: editedRow?.customFields,
        where: editedRow?.where,
        sqlCode: "",
      });

      setSelectedEnvironment(testEnvironment);
      setSelectedTestGroupCode(selectedGroupCode);
    }
  }, [editedRow]);

  useEffect(() => {
    if (newValidationRuleModalEnabled) {
      showDrawer(RowAction.Create);
      let newTestRow = testRow;
      if (!newTestRow) {
        newTestRow = {};
      }
      if (selectedGroupCode) {
        setGroupCodeInput(selectedGroupCode);
        newTestRow.groupCode = selectedGroupCode;
      }
      if (selectedEntity) {
        setEntityInput(selectedEntity?.toString());
        newTestRow.entity = entities.find(
          (x: any) => x.id === selectedEntity
        )?.name;
        newTestRow.entityID = selectedEntity;
      }
      setTestRow({ ...newTestRow });
      setEditedRow({ ...newTestRow })
    }
  }, [newValidationRuleModalEnabled]);

  useEffect(() => {
    ValidationRulesService.getAllCategories().then((response: any) => {
      const responseData = response.data;
      setCategories(responseData);
    });

    ReferenceService.getReferenceValidationTypes().then((response: any) => {
      const responseData = response.data;
      setValidationTypes(responseData);
    });
  }, []);

  useEffect(() => {
    if (selectedEntity && categories) {
      setIsTableLoading(true);
    }
  }, [selectedEntity, selectedGroupCode, categories]);

  useEffect(() => {
    if (isTableLoading && categories && selectedEntity) {
      getValidationRules();
    }
  }, [isTableLoading, selectedEntity, categories]);

  const getValidationRules = () => {
    ValidationRulesService.getAll().then((response: any) => {
      const responseData = response.data;
      setData(
        responseData
          .filter(
            (x: any) =>
              (selectedGroupCode
                ? x.groupCode === selectedGroupCode || !x.groupCode || x.groupCode === ""
                : !x.groupCode || x.groupCode === "") &&
              x.entityID === selectedEntity.toString()
          )
          .map((x: any) => ({
            ...x,
            key: x.id,
            category: categories.find((y: any) => y.id === x.categoryId)
              ?.name,
          }))
          .sort((a, b) => a.groupCode ? a.groupCode.localeCompare(b.groupCode ?? "") : "".localeCompare(b.groupCode ?? ""),)
      );
      setIsTableLoading(false);
    });
  }

  const handleOpenPopConfirm = (newOpen: boolean) => {
    if (!newOpen) {
      setPopConfirmOpen(newOpen);
      return;
    }
    if (!isDirty) {
      onClose();
    } else {
      setPopConfirmOpen(newOpen);
    }
  }

  const ReferenceModalOnOk = ()=> {
    const rule = `ISNULL(W.[${fields.find(x=>x.id == fieldInput).name}],'') <> '' AND ref.[AllowedValue] IS NULL`
    setRuleInput(rule);
    
    const join = `LEFT JOIN dp_admin.Validation.reference ref ON ref.[ValidationType] = '${selectedValidationType}' AND ref.AllowedValue = W.[${fields.find(x=>x.id == fieldInput).name}]`;
    setJoinInput(join);
    
    let description = descriptionInput;
    if (description == "") {
      description = "Reference issue";
      setDescriptionInput(description);
    }

    let howToSolve = howToSolveInput;
    if (howToSolve == "") {
      howToSolve = "Replace the current value with a valid value from the reference list. If value is correct, then please update the reference list.";
      setHowToSolveInput(howToSolve);
    }

    let longDescription = longDescriptionInput;
    if (longDescription == "") {
      longDescription = "Only values from the reference list with validation type 'ValidationType' are allowed for this column.";
      setLongDescriptionInput(longDescription);
    }
    
    setCategoryInput(categories.find(x=>x.name === "Reference").id);
    setEditedRow({...editedRow, description: description, howToSolve: howToSolve, longDescription: longDescription, join: join, rule: rule, category: categories.find(x=>x.name === "Reference").id})
    setValidationTypeModalVisible(false);
    setSelectedValidationType("");
    setUpsertButtonEnabled(true);
  }

  useEffect(() => {
    if (entityInput) {
      const model: GetTablesRequest = {
        entityId: selectedEntity,
        groupCode: "",
        operationId: OPERATIONS.VALIDATION,
      };

      TablesService.getTables(model).then((response: any) => {
        if (response.data && response.data.length > 0) {
          const responseData = response.data[0];
          setDestinationTable(responseData.id);
        }
      });
    }
  }, [entityInput]);

  useEffect(() => {
    if (destinationTable) {
      const model: GetFieldsRequest = {
        tableId: destinationTable,
      };

      TablesService.getFields(model).then((response: any) => {
        if (response.data && response.data.length > 0) {
          const responseData = response.data;
          setFields(responseData);
        }
      });
    }
  }, [destinationTable]);

  const columns: ColumnsType<DataType> = [
    {
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationRules.Table.Headers.GroupCode",
        {
          lngs: i18n.languages,
          defaultValue: "Group Code",
        }
      ),
      dataIndex: "groupCode",
      key: "groupCode",
      width: "200px",
      filters: [],
      filterMode: "tree",
      sorter: (a, b) => a.groupCode ? a.groupCode.localeCompare(b.groupCode ?? "") : "".localeCompare(b.groupCode ?? ""),
    },
    {
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationRules.Table.Headers.Id",
        {
          lngs: i18n.languages,
          defaultValue: "Id",
        }
      ),
      dataIndex: "id",
      key: "id",
      // width: "100px",
      filters: [],
      filterMode: "tree",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationRules.Table.Headers.Field",
        {
          lngs: i18n.languages,
          defaultValue: "Field",
        }
      ),
      dataIndex: "fieldName",
      key: "fieldName",
      // width: "100px",
      filters: [],
      filterMode: "tree",
      sorter: (a, b) => a.fieldName ? a.fieldName.trim().localeCompare(b.fieldName ? b.fieldName.trim() : "") : "".localeCompare(b.fieldName ? b.fieldName.trim() : ""),
    },
    {
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationRules.Table.Headers.Category",
        {
          lngs: i18n.languages,
          defaultValue: "Category",
        }
      ),
      dataIndex: "category",
      key: "category",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      sorter: (a, b) => a.category ? a.category.localeCompare(b.category ?? "") : "".localeCompare(b.category ?? ""),
    },
    {
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationRules.Table.Headers.Description",
        {
          lngs: i18n.languages,
          defaultValue: "Description",
        }
      ),
      dataIndex: "description",
      key: "description",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      sorter: (a, b) => a.description ? a.description.trim().localeCompare(b.description ? b.description.trim() : "") : "".localeCompare(b.description ? b.description.trim() : ""),
    },
    {
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationRules.Table.Headers.Mandatory",
        {
          lngs: i18n.languages,
          defaultValue: "Mandatory",
        }
      ),
      dataIndex: "mandatory",
      key: "mandatory",
      width: "150px",
      align: "center",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      sorter: (a, b) => a.mandatory ? Number(a.mandatory) - Number(b.mandatory ? b.mandatory : false) : Number(false) - Number(b.mandatory ? b.mandatory : false),
    },
    {
      title: t(
        "Page.Operation.ValidationRules.Tabs.ValidationRules.Table.Headers.Active",
        {
          lngs: i18n.languages,
          defaultValue: "Is Active",
        }
      ),
      dataIndex: "isActive",
      key: "isActive",
      width: "100px",
      align: "center",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      sorter: (a, b) => a.isActive ? Number(a.isActive) - Number(b.isActive ? b.isActive : false) : Number(false) - Number(b.isActive ? b.isActive : false),
    },
    {
    title: t(
          "Page.Operation.ValidationRules.Tabs.ValidationRules.Table.Headers.isAutomaticRule",
          {
            lngs: i18n.languages,
            defaultValue: "isAutomaticRule",
          }
      ),
          dataIndex: "isAutomaticRule",
          key: "isAutomaticRule",
          width: "150px",
          align: "center",
          filters: [],
          filterMode: "tree",
          filterSearch: true,
          sorter: (a, b) => a.isAutomaticRule ? Number(a.isAutomaticRule) - Number(b.isAutomaticRule ? b.isAutomaticRule : false) : Number(false) - Number(b.isAutomaticRule ? b.isAutomaticRule : false),
    },
  ];

  const scroll = { y: "calc(100vh - 350px)"  };

  return (
    <div className="validation-rules-tab-container">
      {!selectedEntity ? (
        <Empty
          style={{ display: "flex", width: "100%" }}
          description={t(
            "Page.Operation.ValidationRules.Tabs.ValidationRules.Tutorial.GetStarted",
            {
              lngs: i18n.languages,
              defaultValue: "Please select an entity to get started",
            }
          )}
        ></Empty>
      ) : (
        <Datatable
          scroll={scroll}
          tableColumns={columns}
          data={data}
          setData={setData}
          isTableLoading={isTableLoading}
          otherActions={[]}
          otherRowEnabled={false}
          editRowEnabled={true}
          copyRowEnabled={true}
          deleteRowEnabled={true}
          onEditFunc={onEditValidation}
          onCopyFunc={onCopyValidation}
          onDeleteFunc={onDeleteValidation}
          onDoubleClickRow={onDoubleClickRow}
          selectable={selectable}
          multiSelect={multiSelect}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          checkPermissions={true}
          paginationDisabled={true}
        ></Datatable>
      )}
      <Drawer
        width={"400px"}
        getContainer={false}
        style={{ position: "absolute" }}
        title={drawerTitle}
        placement={DRAWER_PLACEMENTS.BOTTOM}
        onClose={onClose}
        visible={openDrawer}
        closable={false}
        height={"670px"}
        extra={
          <Space>
            {RowAction?.View === drawerAction && (
              <>
                <Button
                  onClick={() => showDrawer(RowAction.Edit)}
                  icon={<EditOutlined />}
                  className={"active-btn"}
                  size="small"
                >
                  {t("General.Labels.Edit", {
                    lngs: i18n.languages,
                    defaultValue: "Edit",
                  })}
                </Button>
                <Button
                  type="ghost"
                  onClick={onClose}
                  icon={<CloseOutlined />}
                  size="small"
                />
              </>
            )}
            {RowAction?.Create === drawerAction && (
              <>
                <Button
                  // disabled={!updateRowAllowed}
                  // className={!updateRowAllowed ? "" : "active-btn"}
                  onClick={onShowTestDrawer}
                  icon={<ExperimentOutlined />}
                  size="small"
                  loading={loadingButton}
                >
                  {t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ActionTest",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Test",
                    }
                  )}
                </Button>
                <Button
                  // disabled={!valueInput}
                  // className={!valueInput ? "" : "active-btn"}
                  onClick={onSaveValidation}
                  icon={<CheckOutlined />}
                  size="small"
                  loading={loadingButton}
                  disabled={!upsertButtonEnabled}
                >
                  {t("General.Labels.Save", {
                    lngs: i18n.languages,
                    defaultValue: "Save",
                  })}
                </Button>
                <Popconfirm
                    style={{ width: "400px" }}
                    placement="topRight"
                    title={
                      <div
                          style={{
                            width: "400px",
                            wordBreak: "break-word",
                          }}
                      >
                        {t(
                            "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ConfirmClose",
                            {
                              lngs: i18n.languages,
                              defaultValue:
                                  "Are you really sure that you want to close this drawer? All changes made will be lost.",
                            }
                        )}
                      </div>
                    }
                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                    visible={popConfirmOpen}
                    onVisibleChange={handleOpenPopConfirm}
                    onConfirm={() => onClose()}
                    // onCancel={() => cancel}
                    okText={t("General.Actions.Yes", {
                      lngs: i18n.languages,
                      defaultValue: "Yes",
                    })}
                    cancelText={t("General.Actions.No", {
                      lngs: i18n.languages,
                      defaultValue: "No",
                    })}
                >
                  <Button
                      type="ghost"
                      icon={<CloseOutlined />}
                      size="small"
                  />
                </Popconfirm>
              </>
            )}
            {RowAction?.Edit === drawerAction && (
              <>
                <Button
                  // disabled={!updateRowAllowed}
                  // className={!updateRowAllowed ? "" : "active-btn"}
                  onClick={onShowTestDrawer}
                  icon={<ExperimentOutlined />}
                  size="small"
                  loading={loadingButton}
                >
                  {t(
                    "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ActionTest",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Test",
                    }
                  )}
                </Button>
                <Button
                  // disabled={!updateRowAllowed}
                  // className={!updateRowAllowed ? "" : "active-btn"}
                  onClick={onSaveValidation}
                  icon={<CheckOutlined />}
                  size="small"
                  loading={loadingButton}
                  disabled={!upsertButtonEnabled}
                >
                  {t("General.Labels.Update", {
                    lngs: i18n.languages,
                    defaultValue: "Update",
                  })}
                </Button>
                <Popconfirm
                    style={{ width: "400px" }}
                    placement="topRight"
                    title={
                      <div
                          style={{
                            width: "400px",
                            wordBreak: "break-word",
                          }}
                      >
                        {t(
                            "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ConfirmClose",
                            {
                              lngs: i18n.languages,
                              defaultValue:
                                  "Are you really sure that you want to close this drawer? All changes made will be lost.",
                            }
                        )}
                      </div>
                    }
                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                    visible={popConfirmOpen}
                    onVisibleChange={handleOpenPopConfirm}
                    onConfirm={() => onClose()}
                    // onCancel={() => cancel}
                    okText={t("General.Actions.Yes", {
                      lngs: i18n.languages,
                      defaultValue: "Yes",
                    })}
                    cancelText={t("General.Actions.No", {
                      lngs: i18n.languages,
                      defaultValue: "No",
                    })}
                >
                  <Button
                      type="ghost"
                      icon={<CloseOutlined />}
                      size="small"
                  />
                </Popconfirm>
              </>
            )}
          </Space>
        }
      >
        <Form
          disabled={RowAction.View === drawerAction ? true : false}
          layout="vertical"
        >
          <div className="validation-drawer">
            <div className="validation-form-top">
              <Form.Item
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.GroupCode",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Group code",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.GroupCode",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  showSearch={true}
                  showArrow={true}
                  options={groupCodes.map((x: any) => ({
                    label: x.code,
                    value: x.code,
                  }))}
                  value={groupCodeInput}
                  filterSort={(optionA, optionB) =>
                      (optionA!.label as unknown as string)
                          .toLowerCase()
                          .localeCompare(
                              (optionB!.label as unknown as string).toLowerCase()
                          )
                  }
                  onChange={onGroupCodeChange}
                ></Select>
              </Form.Item>
              <Form.Item
                required
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Entity",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Entity",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Entity",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  showSearch={true}
                  showArrow={true}
                  filterSort={(optionA, optionB) =>
                      (optionA!.label as unknown as string)
                          .toLowerCase()
                          .localeCompare(
                              (optionB!.label as unknown as string).toLowerCase()
                          )
                  }
                  options={entities.map((x: any) => ({
                    label: x.name,
                    value: x.id.toString(),
                  }))}
                  filterOption={(inputValue: any, option: any) =>
                      option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  value={entityInput}
                  onChange={onEntityChange}
                ></Select>
              </Form.Item>

              <Form.Item
                required
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Field",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Field",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Field",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  showSearch={true}
                  showArrow={true}
                  filterSort={(optionA, optionB) =>
                      (optionA!.label as unknown as string)
                          .toLowerCase()
                          .localeCompare(
                              (optionB!.label as unknown as string).toLowerCase()
                          )
                  }
                  options={fields.map((x: any) => ({
                    label: x.name,
                    value: `${x.id}`,
                  }))}
                  filterOption={(inputValue: any, option: any) =>
                      option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  value={fieldInput}
                  onChange={onFieldChange}
                ></Select>
              </Form.Item>
              <Form.Item
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Category",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Category",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Category",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
                required
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  showSearch={true}
                  showArrow={true}
                  filterSort={(optionA, optionB) =>
                      (optionA!.label as unknown as string)
                          .toLowerCase()
                          .localeCompare(
                              (optionB!.label as unknown as string).toLowerCase()
                          )
                  }
                  options={categories?.map((x: any) => ({
                    label: x.name,
                    value: x.id,
                  }))}
                  filterOption={(inputValue: any, option: any) =>
                      option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  value={categoryInput}
                  onChange={onCategoryChange}
                ></Select>
              </Form.Item>
              <Form.Item
                hidden={categoryInput !== 2}
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Dependency",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Dependency",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Dependency",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  disabled={categoryInput !== 2}
                  showSearch={true}
                  showArrow={true}
                  options={entities
                    .filter((x:any) => x.id.toString() !== entityInput)
                    .map((x: any) => ({
                    label: x.name,
                    value: x.id.toString(),
                  }))}
                  filterOption={(inputValue: any, option: any) =>
                      option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  value={dependencyInput}
                  onChange={onDependencyChange}
                ></Select>
              </Form.Item>
              <div className="checkboxes">
                <Form.Item
                  // className={styles.mb10px}
                  required
                  tooltip={t(
                    "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.IsActive",
                    {
                      lngs: i18n.languages,
                      defaultValue: "",
                    }
                  )}
                >
                  <Checkbox
                    checked={activeInput}
                    onClick={() => onActiveChange(!activeInput)}
                  >
                    {t(
                      "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.IsActive",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Is Active",
                      }
                    )}
                  </Checkbox>
                </Form.Item>
                <Form.Item
                      // className={styles.mb10px}
                      required
                      tooltip={t(
                          "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Mandatory",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                      )}
                >
                  <Checkbox
                      checked={mandatoryInput}
                      onClick={() => onMandatoryChange(!mandatoryInput)}
                  >
                    {t(
                        "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Mandatory",
                        {
                          lngs: i18n.languages,
                          defaultValue: "Mandatory",
                        }
                    )}
                  </Checkbox>
                </Form.Item>
                { showMandatoryWarning && <p>Selected field is mandatory</p> }
              </div>
              <div className="checkboxes">
                <Form.Item
                    tooltip={t(
                        "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.IsAutomaticRule",
                        {
                          lngs: i18n.languages,
                          defaultValue: "",
                        }
                    )}>
                  <Checkbox
                      disabled
                      checked={IsAutomaticRuleInput}
                  >
                    {t(
                        "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.IsAutomaticRule",
                        {
                          lngs: i18n.languages,
                          defaultValue: "Is Automatic Rule",
                        }
                    )}
                  </Checkbox>
                </Form.Item>
              </div>
              <Form.Item
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.RuleTitle",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Rule Title",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.RuleTitle",
                   {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
                required
              >
                <Input
                  placeholder={
                    t("General.Placeholders.EnterValue", {
                      lngs: i18n.languages,
                      defaultValue: "Enter value",
                    })!
                  }
                      value={descriptionInput}
                      onChange={onDescriptionInputChange}
                  // disabled
                ></Input>
              </Form.Item>

              <Form.Item
                label={t(
                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.Sequence",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Sequence",
                  }
                )}
                tooltip={t(
                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.Sequence",
                  { lngs: i18n.languages, defaultValue: "" }
                )}
              >
                <Input
                  placeholder={
                    t("General.Placeholders.EnterValue", {
                      lngs: i18n.languages,
                      defaultValue: "Enter value",
                    })!
                  }
                      value={sequenceInput}
                      onChange={onSequenceInputChange}
                ></Input>
              </Form.Item>
              <Form.Item
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Description",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Description",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Description",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Input.TextArea
                  allowClear
                  // rows={4}
                  value={longDescriptionInput}
                  placeholder={
                    t("General.Placeholders.EnterValue", {
                      lngs: i18n.languages,
                      defaultValue: "Enter value",
                    })!
                  }
                  onChange={onLongDescriptionInputChange}
                ></Input.TextArea>
              </Form.Item>
              <Form.Item
                  label={t(
                      "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.WhoToSolve",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Who to Solve",
                      }
                  )}
                  tooltip={t(
                      "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.WhoToSolve",
                      {
                        lngs: i18n.languages,
                        defaultValue: "",
                      }
                  )}
              >
                <Input.TextArea
                    allowClear
                    // rows={4}
                    value={whoToSolveInput}
                    placeholder={
                      t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })!
                    }
                    onChange={onWhoToSolveInputChange}
                ></Input.TextArea>
              </Form.Item>
              <Form.Item
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.IssueOwner",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Issue Owner",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.IssueOwner",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Input
                  allowClear
                  // rows={4}
                  value={issueOwnerInput}
                  placeholder={
                    t("General.Placeholders.EnterValue", {
                      lngs: i18n.languages,
                      defaultValue: "Enter value",
                    })!
                  }
                  onChange={onIssueOwnerInputChange}
                ></Input>
              </Form.Item>
            </div>
            <div className="validation-form-right">
              <Button className="ant-btn-secondary" onClick = {()=>{setValidationTypeModalVisible(true)}}>
                {t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Button.AddReference",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Add reference",
                  } 
                )}
              </Button>
              <Form.Item
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Rule",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Rule",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Rule",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
                style={{ marginBottom: "10px" }}
              >
                <Input.TextArea
                  allowClear
                  rows={4}
                  value={ruleInput}
                  placeholder={
                    t("General.Placeholders.EnterValue", {
                      lngs: i18n.languages,
                      defaultValue: "Enter value",
                    })!
                  }
                  onChange={onRuleInputChange}
                ></Input.TextArea>
              </Form.Item>
              <Form.Item
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Join",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Join",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Join",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
                style={{ marginBottom: "10px" }}
              >
                <Input.TextArea
                  allowClear
                  rows={12}
                  value={joinInput}
                  placeholder={
                    t("General.Placeholders.EnterValue", {
                      lngs: i18n.languages,
                      defaultValue: "Enter value",
                    })!
                  }
                  onChange={onJoinInputChange}
                ></Input.TextArea>
              </Form.Item>
              <Form.Item
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.IssueValue",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Issue value",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.IssueValue",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
                style={{ marginBottom: "10px" }}
              >
                <Input.TextArea
                  allowClear
                  rows={4}
                  value={issueValueInput}
                  placeholder={
                    t("General.Placeholders.EnterValue", {
                      lngs: i18n.languages,
                      defaultValue: "Enter value",
                    })!
                  }
                  onChange={onIssueValueInputChange}
                ></Input.TextArea>
              </Form.Item>
              <Form.Item
                  label={t(
                      "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.HowToSolve",
                      {
                        lngs: i18n.languages,
                        defaultValue: "How to Solve",
                      }
                  )}
                  tooltip={t(
                      "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.HowToSolve",
                      {
                        lngs: i18n.languages,
                        defaultValue: "",
                      }
                  )}
              >
                <Input.TextArea
                    allowClear
                    // rows={4}
                    value={howToSolveInput}
                    placeholder={
                      t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })!
                    }
                    onChange={onHowToSolveInputChange}
                ></Input.TextArea>
              </Form.Item>
              <Form.Item
                  label={t(
                      "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.ProposedSolution",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Proposed Solution",
                      }
                  )}
                  tooltip={t(
                      "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.ProposedSolution",
                      {
                        lngs: i18n.languages,
                        defaultValue: "",
                      }
                  )}
              >
                <Input.TextArea
                    allowClear
                    // rows={4}
                    value={proposedSolutionInput}
                    placeholder={
                      t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })!
                    }
                    onChange={onProposedSolutionInputChange}
                ></Input.TextArea>
              </Form.Item>
            </div>
          </div>
        </Form>
      </Drawer>
      <Drawer
        height={"95vh"}
        width={"400px"}
        getContainer={false}
        style={{
          position: "absolute",
        }}
        title={t(
          "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Testing",
          {
            lngs: i18n.languages,
            defaultValue: "Testing",
          }
        )}
        placement={DRAWER_PLACEMENTS.BOTTOM}
        onClose={onCloseTestDrawer}
        visible={openTestDrawer}
        closable={false}
        extra={
          <Space>
            <>
              <Button
                icon={<ForwardOutlined />}
                size="small"
                onClick={() => runTest(false)}
              >
                {t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.ActionRun",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Run",
                  }
                )}
              </Button>
              <Button
                  icon={<ForwardOutlined />}
                  size="small"
                  onClick={() => runTest(true)}
              >
                {t(
                    "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.ActionGenerateSQLQuery",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Generate SQL Query",
                    }
                )}
              </Button>
              <Button
                onClick={onTestApplyChanges}
                icon={<CheckOutlined />}
                size="small"
              >
                {t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.ActionApplyChanges",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Apply changes",
                  }
                )}
              </Button>
              <Button
                type="ghost"
                onClick={onCloseTestDrawer}
                icon={<CloseOutlined />}
                size="small"
              />
            </>
          </Space>
        }
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <Form
              form={testValidationRuleForm}
              layout="inline"
              labelCol={{ span: 12 }}
            >
              <Form.Item
                name="groupCode"
                style={{ width: "300px" }}
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.GroupCode",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Group code:",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.GroupCode",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={
                    t("General.Placeholders.SelectOption", {
                      lngs: i18n.languages,
                      defaultValue: "Select option",
                    })!
                  }
                  loading={groupCodes.length === 0}
                  onChange={onTestGroupCodeChange}
                  showSearch={true}
                  showArrow={true}
                  allowClear={true}
                  value={testRow?.groupCode}
                  options={groupCodes.map((x: any) => ({
                    label: x.code,
                    value: x.code,
                  }))}
                  filterSort={(optionA, optionB) =>
                      (optionA!.label as unknown as string)
                          .toLowerCase()
                          .localeCompare(
                              (optionB!.label as unknown as string).toLowerCase()
                          )
                  }
                ></Select>
              </Form.Item>
              <Form.Item
                style={{ width: "300px" }}
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Environment",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Environment:",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationMapping.Tooltips.Environment",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={
                    t("General.Placeholders.SelectOption", {
                      lngs: i18n.languages,
                      defaultValue: "Select option",
                    })!
                  }
                  loading={environment.length === 0}
                  onChange={onEnvironmentChange}
                  showSearch={true}
                  showArrow={true}
                  allowClear={true}
                  value={selectedEnvironment}
                  options={environment.map((x: any) => ({
                    label: x.name,
                    value: x.name,
                  }))}
                  filterSort={(optionA, optionB) =>
                    optionA.value! < optionB.value! ? -1 : 1
                  }
                ></Select>
              </Form.Item>
              <Form.Item
                name="field"
                style={{ width: "300px" }}
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Field",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Field",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Field",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  disabled
                  showSearch={true}
                  showArrow={true}
                  options={fields.map((x: any) => ({
                    label: x.name,
                    value: `${x.id}`,
                  }))}
                  filterOption={(inputValue: any, option: any) =>
                      option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  value={testRow?.field}
                ></Select>
              </Form.Item>
            </Form>
          </div>

          <Pagination
            size="small"
            total={testTableViewData.length}
            current={viewTablePageIndex}
            pageSize={viewTablePageSize}
            showQuickJumper={true}
            showSizeChanger={true}
            locale={{
              items_per_page: t("General.Table.Pagination.ItemPerPage", {
                lngs: i18n.languages,
                defaultValue: "/page",
              })!,
              page: t("General.Table.Pagination.Page", {
                lngs: i18n.languages,
                defaultValue: "page",
              })!,
              jump_to: t("General.Table.Pagination.GoTo", {
                lngs: i18n.languages,
                defaultValue: "Go to",
              })!,
            }}
            showTotal={(total: number, range: [number, number]) => {
              const translation = t("General.Table.Pagination.RangeRecords", {
                lngs: i18n.languages,
                defaultValue: `${range[0]}-${range[1]} out of ${total} records`,
              });
              return `${translation
                .replace("${range[0]}", range[0].toString())
                .replace("${range[1]}", range[1].toString())
                .replace("${total}", total.toString())}`;
            }}
            itemRender={(page: number, type: any, originalElement: any) => {
              return originalElement;
            }}
            onChange={(page: any, size: any) => {
              setViewTablePageIndex(page);
              setViewTablePageSize(size);
            }}
          />
        </div>
        <Datatable
          scroll={false}
          tableColumns={testTableColumns}
          data={testTableViewData}
          setData={setTestTableViewData}
          isTableLoading={isTestTableLoading}
          otherActions={[]}
          otherRowEnabled={false}
          editRowEnabled={false}
          copyRowEnabled={false}
          deleteRowEnabled={false}
          onEditFunc={undefined}
          onCopyFunc={undefined}
          onDeleteFunc={undefined}
          onDoubleClickRow={undefined}
          selectable={false}
          multiSelect={false}
          selectedRows={undefined}
          setSelectedRows={undefined}
          paginationVisible={false}
          paginationPageIndex={viewTablePageIndex}
          paginationPageSize={viewTablePageSize}
          showActionsColumn={false}
          checkPermissions={true}
        ></Datatable>
        <Form layout="vertical" form={testValidationRuleForm}>
          <Form.Item
            name="rule"
            label={t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Rule",
              {
                lngs: i18n.languages,
                defaultValue: "Rule:",
              }
            )}
            tooltip={t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Rule",
              {
                lngs: i18n.languages,
                defaultValue: "",
              }
            )}
          >
            <Input.TextArea
              rows={4}
              allowClear
              placeholder={
                t("General.Placeholders.EnterValue", {
                  lngs: i18n.languages,
                  defaultValue: "Enter value",
                })!
              }
              autoSize
              value={testRow?.rule}
              onChange={onSelectedTestRuleChange}
            ></Input.TextArea>
          </Form.Item>
          <Form.Item
            name="issueValue"
            label={t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.IssueValue",
              {
                lngs: i18n.languages,
                defaultValue: "Issue Value:",
              }
            )}
            tooltip={t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.IssueValue",
              {
                lngs: i18n.languages,
                defaultValue: "",
              }
            )}
          >
            <Input.TextArea
              rows={4}
              allowClear
              placeholder={
                t("General.Placeholders.EnterValue", {
                  lngs: i18n.languages,
                  defaultValue: "Enter value",
                })!
              }
              autoSize
              value={testRow?.issueValue}
              onChange={onSelectedTestIssueValueChange}
            ></Input.TextArea>
          </Form.Item>
          <Form.Item
            name="customFields"
            label={t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.CustomFields",
              {
                lngs: i18n.languages,
                defaultValue: "Custom fields:",
              }
            )}
            tooltip={t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.CustomFields",
              {
                lngs: i18n.languages,
                defaultValue: "",
              }
            )}
          >
            <Input.TextArea
              allowClear
              placeholder={
                t("General.Placeholders.EnterValue", {
                  lngs: i18n.languages,
                  defaultValue: "Enter value",
                })!
              }
              autoSize
              value={testRow?.customFields}
              onChange={onSelectedTestCustomFieldsChange}
            ></Input.TextArea>
          </Form.Item>
          <Form.Item
            name="join"
            label={t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Join",
              {
                lngs: i18n.languages,
                defaultValue: "Join:",
              }
            )}
            tooltip={t(
              "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Join",
              {
                lngs: i18n.languages,
                defaultValue: "",
              }
            )}
          >
            <Input.TextArea
              placeholder={
                t("General.Placeholders.EnterValue", {
                  lngs: i18n.languages,
                  defaultValue: "Enter value",
                })!
              }
              allowClear
              rows={4}
              autoSize
              value={testRow?.join}
              onChange={onSelectedTestJoinChange}
              style={{ whiteSpace: "pre-wrap" }}
              wrap="hard"
            ></Input.TextArea>
          </Form.Item>
          <Form.Item
              name="where"
              label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Where",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Where:",
                  }
              )}
          >
            <Input.TextArea
                placeholder={
                  t("General.Placeholders.EnterValue", {
                    lngs: i18n.languages,
                    defaultValue: "Enter value",
                  })!
                }
                allowClear
                rows={4}
                autoSize
                value={testRow?.where}
                onChange={onSelectedTestWhereChange}
                style={{ whiteSpace: "pre-wrap" }}
                wrap="hard"
            ></Input.TextArea>
          </Form.Item>
        </Form>
        <Collapse bordered={false} defaultActiveKey={['1']}>
          <Panel
            header="SQL"
            key="1"
            extra={
              <Button
                className={styles.copyButton}
                onClick={(event) => {
                  navigator.clipboard.writeText(testRow.sqlCode);
                  event.stopPropagation();
                }}
                icon={<CopyOutlined></CopyOutlined>}
              ></Button>
            }
          >
            {/* {testRow?.sqlCode} */}
            {testRow?.sqlCode?.split("\n").map((item: any) => (
              <>
                {item}
                <br />
              </>
            ))}
          </Panel>
        </Collapse>
      </Drawer>

      <Modal
          title={t("Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Reference", {
            lngs: i18n.languages,
            defaultValue: "Reference",
          })}
          okText={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Automap.Ok", {
            lngs: i18n.languages,
            defaultValue: "Ok",
          })}
          cancelText={t("Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Automap.Cancel", {
            lngs: i18n.languages,
            defaultValue: "Cancel",
          })}
          visible={validationTypeModalVisible}
          onOk={ReferenceModalOnOk}
          okButtonProps={{ disabled: !selectedValidationType || !fieldInput}}
          onCancel={()=>{setValidationTypeModalVisible(false)}}
          >
        <Form
            layout="vertical"
        >
            
            <Form.Item
                required
                label={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.Field",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Field",
                  }
                )}
                tooltip={t(
                  "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.Field",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  showSearch={true}
                  showArrow={true}
                  options={fields.map((x: any) => ({
                    label: x.name,
                    value: `${x.id}`,
                  }))}
                  filterOption={(inputValue: any, option: any) =>
                      option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  value={fieldInput}
                  onChange={onFieldChange}
                ></Select>
              </Form.Item>
            <Form.Item required label={t("Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.ValidationType", {
            lngs: i18n.languages,
            defaultValue: "Validation Type",
          })}>
                  <Select
                    options= {
                      validationTypes.map((x: string) => ({
                        label: x,
                        value: x,
                      }))
                    }
                    onChange={setSelectedValidationType}
                    value={selectedValidationType}
                  />
            </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ValidationRules;
